import React, { useState } from 'react';
import { Box, Button, IconButton, Paper, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { AttachFile } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { TNtfyNew } from '../../_types/ntfy';
import { NtfyReport } from '../../features/store/ntfy.slice';
import { useDispatch } from 'react-redux';

const Activate: React.FC = (): React.JSX.Element => {
  const [file, setFile]: any = useState();
  const [activationReady, setActivationReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const dispatch = useDispatch<any>();

  function handleChange(event: any) {
    setFile(event.target.files[0])
  }

  function onUploadClick() {
    const url = '/activation_upload';

    const formData = new FormData();
    // @ts-ignore
    formData.append('activation', file);
    // @ts-ignore
    //formData.append('fileName', file.name);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
      responseType: 'arraybuffer',
    };

    setBusy(true);

    // @ts-ignore
    axios.post(url, formData, config)
      .then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream'
          });

          const a = document.createElement('a');
          const url = URL.createObjectURL(blob);
          a.href = url;
          a.download = 'Activate.zip';
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);

          setActivationReady(true);
          setBusy(false);
        }
      })
      .catch((err) => {
        const notification = TNtfyNew(err.message, 'error', 'long');
        dispatch(NtfyReport(notification));
        setBusy(false);
      });
  }

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, mx: 'auto' }}>
        {!activationReady ? (
          <>
            <Typography variant="h2" gutterBottom>
              USB Activation
            </Typography>

            <Typography variant="body1" gutterBottom>
              <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                <li>1. Insert the USB flash drive into an available port on the computer.</li>
                <li>2. Click the paperclip icon below.</li>
                <li>3. Select the USB drive and double‑click the Activation.zip file.</li>
                <li>4. Click the green Activate button when it appears.</li>
                <li>
                  <TextField
                    value={file ? file.name : ''}
                    onKeyDown={() => false}
                    helperText={!file ? 'click the paperclip icon to choose a file' : ''}
                    variant="outlined"
                    type="text"
                    sx={{ mt: 2, maxWidth: '400px' }}
                    InputProps={{
                      endAdornment: (
                        <IconButton component="label">
                          <AttachFile />
                          <input
                            disabled={busy}
                            type="file"
                            hidden
                            onChange={handleChange}
                            accept=".zip"
                          />
                        </IconButton>
                      ),
                    }}
                  />
                </li>

                {file && (
                  <li>
                    <LoadingButton
                      loading={busy}
                      sx={{ mt: 2 }}
                      variant="contained"
                      size="large"
                      color="success"
                      onClick={onUploadClick}
                    >Activate</LoadingButton>
                  </li>
                )}
              </ul>
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h2" gutterBottom>
              Activation Ready
            </Typography>

            <Typography variant="body1" gutterBottom>
              <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                <li>1. Save the downloaded Activate.zip to the USB flash drive.</li>
                <li>2. Eject the USB drive from the laptop.</li>
                <li>3. Insert the USB drive into the aligner.</li>
                <li>4. Follow the instructions on the aligner to complete activation.</li>
                <li>
                  <Button
                    sx={{ mt: 2 }}
                    variant="contained"
                    size="large"
                    color="success"
                    onClick={() => {
                      setFile(null);
                      setActivationReady(false);
                    }}
                  >Activate Another</Button>
                </li>
              </ul>
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Activate;
